import useMenu from './useMenu';

export default useMenu;
